// OcSinRegistrarCard — alerta en /customerOrders con las OC ENTRANTES sin
// registrar (mailEntrantes tipo "oc", estado != "registrada"; mismo origen que
// /oc-entrantes). Cada una lleva a: (1) el form precargado (?oc&cliente&mailId)
// para registrarla, y (2) previsualizar/enviar el acuso de recibo.
// Autocontenido: si no hay pendientes, no renderiza nada.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backend from "../../backend";
import AcusoPreviewModal from "./AcusoPreviewModal";

const OcSinRegistrarCard = () => {
  const navigate = useNavigate();
  const [ocs, setOcs] = useState([]);
  const [acusoMail, setAcusoMail] = useState(null);

  const cargar = () => {
    backend.get("mailEntrante", { params: { estado: "pendiente" } })
      .then(({ data }) => setOcs((data || []).filter(m => m.tipoDetectado === "oc" && m.direccion !== "enviado")))
      .catch(() => setOcs([]));
  };
  useEffect(() => { cargar(); }, []);

  if (!ocs.length) return null;

  const registrar = m => navigate(
    "/customerOrders?oc=" + encodeURIComponent(m.ocNumero || "") +
    "&cliente=" + encodeURIComponent(m.clienteDetectado || "") +
    "&mailId=" + m._id
  );

  return (
    <div style={{
      background: "#2d2410", border: "1px solid #6b5312", borderRadius: 8,
      padding: "12px 14px", marginBottom: 14, color: "#f0e6c8", fontFamily: "Arial, sans-serif",
    }}>
      <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8, color: "#f5d76e" }}>
        ⚠ {ocs.length} OC entrante{ocs.length > 1 ? "s" : ""} SIN REGISTRAR
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {ocs.slice(0, 8).map(m => (
          <div key={m._id} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", fontSize: 12 }}>
            <span style={{ flex: "1 1 220px", minWidth: 0 }}>
              <strong>{m.ocNumero ? `OC ${m.ocNumero}` : "(sin N° OC)"}</strong>
              {m.clienteDetectado ? ` · ${m.clienteDetectado}` : ""}
              {m.asunto ? <span style={{ color: "#c9bd94" }}> · {m.asunto}</span> : null}
            </span>
            <button onClick={() => registrar(m)} style={btn("#f39c12", "#2a1c00")}>Registrar</button>
            <button onClick={() => setAcusoMail(m)} style={btn("#3a3a3a", "#eee")}>Ver acuso</button>
          </div>
        ))}
        {ocs.length > 8 && (
          <button onClick={() => navigate("/oc-entrantes")} style={{ ...btn("transparent", "#f5d76e"), textDecoration: "underline", padding: "2px 0" }}>
            ver las {ocs.length} en OC entrantes →
          </button>
        )}
      </div>
      <AcusoPreviewModal mailId={acusoMail?._id} onClose={() => setAcusoMail(null)} onSent={cargar} />
    </div>
  );
};

const btn = (bg, fg) => ({
  background: bg, color: fg, border: "none", borderRadius: 5,
  padding: "5px 11px", fontSize: 12, fontWeight: 600, cursor: "pointer",
  fontFamily: "Arial, sans-serif", whiteSpace: "nowrap",
});

export default OcSinRegistrarCard;
